import React, { useEffect, useState } from "react";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow, UNO_URL } from "../../Server";
import swal from "sweetalert";
import axios from "axios";
import { withRouter, useHistory, useParams } from "react-router-dom";
import { HomeIcon } from "../../assets/Icons";
import { connect } from "react-redux";
import HeaderMobileSearch from "../../common/HeaderMobileSearch";
import HeaderMobile from "../../common/HeaderMobile";
import NoDataFound from "../../common/NoDataFound";
import TableSkelton from "../../skeltonloader/TableSkelton";
import UserStripCard from "../../common/UserStripCard";
import GroupUserCard from "../../common/GroupUserCard";
import gailLogo from "../../assets/images/gailLogo.png";
import userImage from "../../assets/images/ui-images/image-rounded.jpg";
import PlaceholderCard from "../../common/PlaceholderCard";
import Search from "../../common/Search";
import SiteDashboard from "../Dashboard/SiteDashboard";
import { saveUserDetails } from "../../redux/actions/User.action";
import { useSelector } from "react-redux";

const AssignedWorkFlowList = ({ selectedUser }) => {
  const [loading, setLoading] = useState(false);
  const [workflowList, setWorkflowList] = useState([]);
  const history = useHistory();
  const { userDetails } = useSelector((state) => state.userData);
  const { uuid } = useParams();

  const handleGetUserWorkflows = async (uuid) => {
    setWorkflowList([]);
    setLoading(true);
    try {
      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };

      let bodyData = {
        userId: uuid,
        groupId: userDetails.user.groupId,
      };

      let { data } = await axios.post(`${SERVER_IP}/user/assign/workflow/list`, bodyData, {
        withCredentials: true,
        headers: headers,
      });
      setWorkflowList(data.workflowList);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClickSeeSession = (list) => {
    sessionStorage.setItem("report_info_workflow", JSON.stringify(list));
    history.push("/create/alignedworkflowsession");
  };

  useEffect(() => {
    handleGetUserWorkflows(uuid);
  }, [uuid]);

  return (
    <>
      <div className="myactivity">
        <div className="xp-breadcrumbbar xp-heading">
          <h4>Workflows List</h4>
        </div>
        <div className="xp-contentbar p-30 pb-0 user-group-content ">
          <div className="row h-100">
            <div className="col-lg-12 h-100">
              <div className="assignedtabcontent bg-white p-3">
                <div className="table-responsive">
                  <table className="table table-striped table-bordered mcqlist-taable">
                    <thead>
                      <tr>
                        <th className="text-center">S.N.</th>
                        <th className="text-left" style={{ width: "20rem" }}>
                          Name
                        </th>
                        <th className="text-left">Description</th>
                        <th className="text-center" style={{ width: "10rem" }}>
                          Published On
                        </th>
                        <th className="text-center" style={{ width: "8rem" }}>
                          On Going
                        </th>
                        <th className="text-center">Completed</th>
                        <th className="text-center" style={{ width: "8rem" }}>
                          Session
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <TableSkelton rowCount={3} colCount={7} />
                      ) : workflowList.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center message-no-record">
                            <NoDataFound headText="No Data Found" />
                          </td>
                        </tr>
                      ) : (
                        workflowList.map((list, index) => (
                          <tr key={index}>
                            <td className="text-center">{index + 1}</td>
                            <td className="text-left">{list.workflow_name}</td>
                            <td className="text-left">{list.workflow_description}</td>
                            <td className="text-center">{list.workflow_publishdate}</td>
                            <td className="text-center">
                              <span>
                                <strong>
                                  {list.workflow_total_ongoing == null ? 0 : list.workflow_total_ongoing}{" "}
                                </strong>
                              </span>
                            </td>
                            <td className="text-center">
                              <span>
                                <strong>
                                  {list.workflow_total_completed == null ? 0 : list.workflow_total_completed}{" "}
                                </strong>
                              </span>
                            </td>
                            <td className="text-center">
                              <div
                                className="tabledit-toolbar btn-toolbar"
                                style={{ margin: "0 auto", display: "block" }}
                              >
                                <div className="btn-group btn-group-sm">
                                  <button
                                    type="button"
                                    onClick={() => handleClickSeeSession(list)}
                                    className="btn text-blue"
                                  >
                                    See Session
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignedWorkFlowList;
